import CrudCustom from '../../../libs/custom/CrudCustom';

let TarifBiayaService = new CrudCustom('/tarif-biayas');
export default TarifBiayaService;
